import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import Unauthorized from "../general/Unauthorized";
import Loading from "../general/Loading";
import SelectorCiudad from "../custom/SelectorCiudad";
import SelectorPais from "../custom/SelectorPais";
import SelectorTipoDocumento from "../custom/SelectorTipoDocumento";
import SelectorZona from "../custom/SelectorZona";
import CampoNit from "../custom/CampoNit";

function EditarEmpresa() {

    // Estados para datos de la empresa
    const [idEmpresa, setIdEmpresa] = useState('');
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [digitoVerificacion, setDigitoVerificacion] = useState('');
    const [descripcion, setDescripcion] = useState('');
    
    // Estados para domicilio
    const [direccion, setDireccion] = useState('');
    const [ciudadResidencia, setCiudadResidencia] = useState(null);
    const [paisResidencia, setPaisResidencia] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');

    // Estados de control
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [errorlist, setErrorlist] = useState({});

    // Función para manejar el cambio del NIT y DV
    const handleNitChange = (nit, dv) => {
        setNumeroDocumento(nit);
        setDigitoVerificacion(dv);
    };

    let history = useHistory();
    let location = useLocation();
    let userdata = [];

    // Obtener ID de la empresa desde la URL
    const getIdFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get('id');
    };

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            setLoadingData(false);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'crearPacientes');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('crearPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            setLoadingData(false);
            return;
        }

        setHasPermission(true);

        // ✅ Cargar datos del cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
                setLoggedIn(true);
            });

        // ✅ Cargar datos de la empresa
        const empresaId = getIdFromUrl();
        if (!empresaId) {
            console.error('No se proporcionó ID de empresa');
            setLoadingData(false);
            return;
        }

        setIdEmpresa(empresaId);

        axios.get(`/empresa/${empresaId}`)
            .then(response => {
                if (response.status === 200) {
                    const empresa = response.data;
                    console.log('📥 Datos de empresa cargados:', empresa);
                    
                    // Cargar datos básicos
                    setNombreEmpresa(empresa.primer_nombre || '');
                    setTipoDocumento(empresa.tipo_documento || '');
                    setNumeroDocumento(empresa.numero_documento || '');
                    setDigitoVerificacion(empresa.dv || '');
                    setDescripcion(empresa.nombre_ocupacion || '');
                    
                    // Cargar domicilio
                    setDireccion(empresa.direccion || '');
                    setCiudadResidencia(empresa.ciudad || null);
                    setPaisResidencia(empresa.pais_residencia || '');
                    setZona(empresa.zona || '');
                    setTelefono(empresa.telefono || '');
                    setCelular(empresa.celular || '');
                    setEmail(empresa.email || '');
                    
                    setLoadingData(false);
                }
            })
            .catch(error => {
                console.error('Error cargando empresa:', error);
                setLoadingData(false);
            });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validaciones del lado del cliente
        const errores = {};
        
        if (!nombreEmpresa.trim()) {
            errores.primer_nombre = ['El nombre de la empresa es obligatorio'];
        }
        
        if (!tipoDocumento) {
            errores.tipo_documento = ['El tipo de documento es obligatorio'];
        }
        
        if (!numeroDocumento.trim()) {
            errores.numero_documento = ['El número de documento es obligatorio'];
        }
        
        // Validación opcional del email si se proporciona
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errores.email = ['El formato del email no es válido'];
        }
        
        // Si hay errores, mostrarlos y no enviar
        if (Object.keys(errores).length > 0) {
            setErrorlist(errores);
            return;
        }
        
        setLoading(true);

        // Datos para actualizar empresa
        const data = {
            id: idEmpresa,
            primer_nombre: nombreEmpresa,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,
            dv: digitoVerificacion ? String(digitoVerificacion) : null,
            nombre_ocupacion: descripcion,
            direccion: direccion,
            ciudad: ciudadResidencia,
            pais_residencia: paisResidencia,
            zona: zona,
            telefono: telefono,
            celular: celular,
            email: email
        };

        console.log('📤 Enviando datos para actualizar:', data);

        // ✅ Actualizar empresa
        axios.put('/empresa', data)
            .then(response => {
                setLoading(false);
                console.log('✅ Empresa actualizada exitosamente');
                localStorage.setItem('msgtoast', 'Empresa actualizada exitosamente');
                history.push('/empresas');
            })
            .catch(error => {
                setLoading(false);
                console.error('❌ Error actualizando empresa:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({ general: ['Error al actualizar la empresa'] });
                }
            });
    };

    useEffect(() => {
        if (Object.keys(errorlist).length > 0) {
            const timer = setTimeout(() => {
                setErrorlist({});
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [errorlist]);

    // Protección de ruta estándar
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn || loadingData) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="patients" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item"><Link to="/empresas">Empresas</Link></li>
                                    <li className="breadcrumb-item active">Editar Empresa</li>
                                </ol>

                                {Object.keys(errorlist).length > 0 && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        <ul className="mb-0">
                                            {Object.values(errorlist).map((messages, index) => (
                                                <li key={index}>{Array.isArray(messages) ? messages[0] : messages}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Editar Empresa</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <div className="row">
                                <div className="col-md-11">

                                    {/* Datos de la Empresa */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">
                                                <i className="fas fa-building mr-2"></i>
                                                Datos de la Empresa
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombreEmpresa">Nombre de la Empresa *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            id="nombreEmpresa" 
                                                            value={nombreEmpresa} 
                                                            onChange={(e) => setNombreEmpresa(e.target.value)}
                                                            required
                                                        />
                                                        {errorlist.primer_nombre && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.primer_nombre[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="descripcion">Descripción</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            id="descripcion" 
                                                            value={descripcion} 
                                                            onChange={(e) => setDescripcion(e.target.value)}
                                                            placeholder="Actividad económica, giro del negocio, etc."
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <SelectorTipoDocumento
                                                        value={tipoDocumento}
                                                        onChange={setTipoDocumento}
                                                        error={errorlist.tipo_documento?.[0]}
                                                        required={true}
                                                    />
                                                </div>
                                                <div className="col-md-8">
                                                    <CampoNit
                                                        valor={numeroDocumento}
                                                        digitoVerificacion={digitoVerificacion}
                                                        onChange={handleNitChange}
                                                        anchoValor="75"
                                                        anchoDigito="25"
                                                    />
                                                    {errorlist.numero_documento && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.numero_documento[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Email</label>
                                                        <input 
                                                            type="email" 
                                                            className="form-control" 
                                                            id="email" 
                                                            value={email} 
                                                            onChange={(e) => setEmail(e.target.value)}
                                                        />
                                                        {errorlist.email && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.email[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Domicilio de la Empresa */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">
                                                <i className="fas fa-map-marker-alt mr-2"></i>
                                                Domicilio de la Empresa
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="direccion">Dirección</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            id="direccion" 
                                                            value={direccion} 
                                                            onChange={(e) => setDireccion(e.target.value)}
                                                        />
                                                        {errorlist.direccion && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.direccion[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ciudadResidencia">Ciudad</label>
                                                        <SelectorCiudad
                                                            value={ciudadResidencia}
                                                            onChange={setCiudadResidencia}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="paisResidencia">País</label>
                                                        <SelectorPais
                                                            value={paisResidencia}
                                                            onChange={setPaisResidencia}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <SelectorZona
                                                        value={zona}
                                                        onChange={setZona}
                                                        error={errorlist.zona?.[0]}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telefono">Teléfono</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            id="telefono" 
                                                            value={telefono} 
                                                            onChange={(e) => setTelefono(e.target.value)}
                                                        />
                                                        {errorlist.telefono && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.telefono[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="celular">Celular</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            id="celular" 
                                                            value={celular} 
                                                            onChange={(e) => setCelular(e.target.value)}
                                                        />
                                                        {errorlist.celular && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.celular[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Botones */}
                                    <div className="row" style={{ marginTop: '20px', marginBottom: '30px' }}>
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                <i className="fas fa-save mr-2"></i>
                                                Guardar Cambios
                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                            <Link to="/empresas" className="btn btn-secondary ml-2">
                                                <i className="fas fa-times mr-2"></i>
                                                Cancelar
                                            </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default EditarEmpresa;
